<div class="content">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="card card-outline card-lightblue">
          <div class="card-header">
            <h3 class="card-title mb-0">
              {{ titulo }}
            </h3>
          </div>

          <div class=" card-body">
            <div class="row">
              <div class="form-group col-md-3">
                <label for="txtDataRegistro" class="mb-1">Data</label>
                <input type="text" id="txtDataRegistro" class="form-control form-control-sm"
                       disabled="true" [value]="model.dataRegistro | date:'dd/MM/yyyy HH:mm:ss'" />
              </div>
              <div class="form-group col-md-3">
                <label for="txtTipoLog" class="mb-1">Ação Realizada</label>
                <input type="text" id="txtTipoLog" class="form-control form-control-sm" disabled="true"
                       [value]="model.tipoLog.descricao" />
              </div>
              <div class="form-group col-md-6">
                <label for="txtNomeUsuario" class="mb-1">Realizado Por</label>
                <input type="text" id="txtNomeUsuario" class="form-control form-control-sm"
                       disabled="true" [value]="model.nomeUsuario" />
              </div>
            </div>

            <div class="row">
              <div class="form-group col-md-12">
                <label for="txtDepois" class="mb-1">Log</label>
                <div class="form-control"
                     [innerHTML]="model.depois"
                     style="min-height: 250px; max-height: 500px; overflow-y: auto;">
                </div>
              </div>
            </div>

          </div>
          <div class="card-footer">
            <button type="button" class="btn btn-default btn-sm" (click)="fechar()">
              <i class="fas fa-times"></i> Fechar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
